export default function Advantages() {
  const advantages = [
    {
      icon: 'ri-factory-line',
      title: 'Produksi Sendiri',
      description: 'Kami memiliki fasilitas produksi modern dengan kontrol kualitas ketat di setiap tahap pembuatan, memastikan produk yang konsisten dan berkualitas tinggi.'
    },
    {
      icon: 'ri-shield-star-line',
      title: 'Kualitas Kuat & Presisi',
      description: 'Setiap produk melalui quality control ketat dengan standar SNI. Ketepatan ukuran dan kekuatan struktur terjamin untuk mendukung konstruksi yang aman dan tahan lama.'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Harga Kompetitif',
      description: 'Harga terbaik tanpa mengorbankan kualitas. Kami memberikan penawaran khusus untuk pembelian dalam jumlah besar dengan sistem pembayaran yang fleksibel.'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Melayani Boyolali & Sekitarnya',
      description: 'Lokasi strategis di Boyolali memudahkan pengiriman ke berbagai wilayah sekitar. Pengiriman tepat waktu sesuai jadwal proyek Anda.'
    },
    {
      icon: 'ri-truck-line',
      title: 'Pesanan Jumlah Besar',
      description: 'Kapasitas produksi tinggi untuk memenuhi kebutuhan proyek skala besar. Kami siap melayani pesanan dalam jumlah banyak dengan pengiriman bertahap sesuai kebutuhan.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Layanan Profesional',
      description: 'Tim berpengalaman siap membantu konsultasi kebutuhan material proyek Anda. Pelayanan ramah dan responsif untuk kepuasan pelanggan.'
    }
  ];

  return (
    <section id="advantages" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Keunggulan <span className="text-orange-600">Kami</span>
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            Mengapa memilih Cobramas Production sebagai partner material bangunan Anda
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {advantages.map((advantage, index) => (
            <div 
              key={index}
              className="bg-gray-50 rounded-xl p-8 hover:bg-orange-50 transition-all duration-300 transform hover:-translate-y-2 cursor-pointer border border-gray-100 hover:border-orange-200"
            >
              <div className="w-16 h-16 bg-orange-600 rounded-xl flex items-center justify-center mb-6 shadow-lg">
                <i className={`${advantage.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{advantage.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{advantage.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-orange-600 to-orange-700 rounded-2xl p-8 md:p-12 text-center shadow-2xl">
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
            Siap Memulai Proyek Anda?
          </h3>
          <p className="text-base text-orange-100 mb-8 max-w-2xl mx-auto">
            Hubungi kami sekarang untuk konsultasi gratis dan dapatkan penawaran terbaik untuk kebutuhan material bangunan proyek Anda
          </p>
          <a 
            href="https://wa.me/6285642080427"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-white text-orange-600 px-8 py-4 rounded-lg text-base font-semibold hover:bg-gray-100 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            Hubungi Cobramas Production Hari Ini
          </a>
        </div>
      </div>
    </section>
  );
}